export default "__VITE_ASSET__CSPy8x2t__"